export class AfsEngineSurveyNavigationMode{
    static get ACCORDION(){
        return 'accordion'
    }

    static get CAROUSEL(){
        return 'carousel'
    }
}